import { useStyleSheet } from '../../../hooks/useStyleSheet';

export const useStyles = () =>
  useStyleSheet(
    (theme) => ({
      root: {
        display: 'grid',
        gridTemplateColumns: 'max-content 5rem max-content',
        alignItems: 'center',
        gap: theme.spacing.secondary,
      },
    }),
    [],
  );
